/* eslint-disable radix */
import RestService from '../services/rest';

async function createDiscountCoupon(newDiscountCoupon) {
  return RestService.postAuthenticated('panel/discountCoupon/create', newDiscountCoupon);
}

async function getListDiscountCoupon(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/discountCoupon/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getDiscountCouponHistory(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/discountCoupon/getHistory?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getCsvDiscountCouponModel() {
  const response = await RestService.getAuthenticated('panel/discountCoupon/csv/model', { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'discount-coupon-modelo.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function updateDiscountCoupon(discountCouponParameter) {
  return RestService.putAuthenticated('panel/discountCoupon/update', discountCouponParameter);
}

async function uploadCsvDiscountCoupon(file) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated('panel/discountCoupon/csv/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function deleteDiscountCoupon(couponId) {
  return RestService.deleteAuthenticated('panel/discountCoupon/deleteCoupon', { couponId });
}


export default {
  createDiscountCoupon,
  getListDiscountCoupon,
  updateDiscountCoupon,
  getDiscountCouponHistory,
  getCsvDiscountCouponModel,
  uploadCsvDiscountCoupon,
  deleteDiscountCoupon,
};
